import React from 'react';
import Icon from '../../../components/AppIcon';

const UserStatsCards = ({ stats }) => {
  const statsConfig = [
    {
      key: 'total',
      label: 'Total de Usuarios',
      icon: 'Users',
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-700'
    },
    {
      key: 'active',
      label: 'Usuarios Activos',
      icon: 'UserCheck',
      color: 'bg-green-500',
      bgColor: 'bg-green-50',
      textColor: 'text-green-700'
    },
    {
      key: 'inactive',
      label: 'Usuarios Inactivos',
      icon: 'UserX',
      color: 'bg-gray-500',
      bgColor: 'bg-gray-50',
      textColor: 'text-gray-700'
    },
    {
      key: 'blocked',
      label: 'Usuarios Bloqueados',
      icon: 'UserMinus',
      color: 'bg-red-500',
      bgColor: 'bg-red-50',
      textColor: 'text-red-700'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statsConfig?.map((config) => (
        <div key={config?.key} className="bg-card rounded-lg border border-border shadow-elevation p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-1">
                {config?.label}
              </p>
              <p className="text-2xl font-bold text-foreground">
                {stats?.[config?.key] || 0}
              </p>
              {config?.key === 'total' && (
                <p className="text-xs text-muted-foreground mt-1">
                  Límite: 50 usuarios
                </p>
              )}
            </div>
            <div className={`w-12 h-12 ${config?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={config?.icon} size={24} className={config?.textColor} />
            </div>
          </div>
          
          {config?.key === 'total' && (
            <div className="mt-4">
              <div className="flex justify-between text-xs text-muted-foreground mb-1">
                <span>Capacidad utilizada</span>
                <span>{Math.round((stats?.total / 50) * 100)}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${
                    (stats?.total / 50) > 0.9 
                      ? 'bg-red-500' 
                      : (stats?.total / 50) > 0.7 
                        ? 'bg-yellow-500' :'bg-green-500'
                  }`}
                  style={{ width: `${Math.min((stats?.total / 50) * 100, 100)}%` }}
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default UserStatsCards;